import { withInstall } from '@vuesax-alpha/utils'
import Row from './src/row.vue'

export const VsRow = withInstall(Row)
export default VsRow

export * from './src/row'
